import { render, staticRenderFns } from "./AppliancesRecording.vue?vue&type=template&id=6ad8bbe0&scoped=true&"
import script from "./AppliancesRecording.vue?vue&type=script&lang=js&"
export * from "./AppliancesRecording.vue?vue&type=script&lang=js&"
import style0 from "./AppliancesRecording.vue?vue&type=style&index=0&id=6ad8bbe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad8bbe0",
  null
  
)

export default component.exports